import React from "react";

const Mivo = () => {
  return <div>{/* <h1>MIVO</h1> */}</div>;
};

export default Mivo;
